const topics = [
  { name: '热血战斗', count: '3,821部', hot: true },
  { name: '甜宠恋爱', count: '4,562部', hot: true },
  { name: '悬疑推理', count: '1,836部', hot: false },
  { name: '奇幻冒险', count: '3,104部', hot: true },
  { name: '异世界转生', count: '2,478部', hot: true },
  { name: '都市职场', count: '1,952部', hot: false },
  { name: '校园青春', count: '2,681部', hot: false },
  { name: '古风仙侠', count: '1,340部', hot: false },
  { name: '搞笑日常', count: '2,105部', hot: false },
  { name: '科幻机甲', count: '987部', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            发现时下最火漫画题材，找到属于你的心头好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-500'
              }`}
            >
              {t.name}
              {t.hot && (
                <span className="inline-flex items-center gap-0.5 text-xs text-accent-600">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
              <span className="text-xs text-foreground-400">{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}